module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/co331z/cover.jpg?1706832480306",
      "alt": "This image is the cover for the book Falling Woman"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Falling Woman\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Winner of the Nebula Award: “A lovely and literate exploration of the dark moment where myth and science meet” (Samuel R. Delany).")]), _c('br'), _c('br'), _vm._v(" When night falls over the Yucatan, the archaeologists lay down their tools. But while her colleagues relax, Elizabeth Butler searches for shadows. A famous scientist with a reputation for eccentricity, she carries a strange secret. Where others see nothing but dirt and bones and fragments of pottery, Elizabeth sees shades of the men and women who walked this ground thousands of years before. She can speak to the past—and the past is beginning to speak back."), _c('br'), _c('br'), _vm._v(" As Elizabeth communes with ghosts, the daughter she abandoned flies to Mexico hoping for a reunion. She finds a mother embroiled in the supernatural, on a quest for the true reason for the Mayans’ disappearance. To dig up the truth, the archaeologist who talks to the dead must learn a far more difficult skill: speaking to her daughter.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Pat Murphy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Eugene R. \"Pat\" Murphy is the executive director of The Community Solution. He co-wrote and co-produced the award-winning documentary The Power of Community: How Cuba Survived Peak Oil, has initiated four major Peak Oil conferences and has given numerous presentations and workshops on the subject. He has extensive construction experience and developed low energy buildings during the nation's first oil crisis.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0